module.exports = __webpack_public_path__ + "media/images/flags/tn-b28715adb6121a5d207a9c3a973674c4.svg";